import axios from 'axios'
import globals from '../config/appconfig'
import i18next from 'i18next';
import ToasterSingleton from "../singleton/ToasterSingleton";
import Utils from "../utils/Utils";
import common_en from "../translations/en/common.json";
import common_it from "../translations/it/common.json";
import React from "react";
import OggettiUtili from "../utils/OggettiUtili.json"

i18next.init({
    interpolation: {escapeValue: false},  // React already does escaping
    lng: globals.lingua_default,                              // language to use
    resources: {
        en: {
            common: common_en               // 'common' is our custom namespace
        },
        it: {
            common: common_it               // 'common' is our custom namespace
        },
    },
});

// Add a request interceptor

class Interceptor {

    constructor() {
        console.log("[DEBUG] Constructing Interceptor");
        this.addResponseInterceptor()
    }


    filterout = (error) => {
        //Ritorna true se l'errore passato come parametro non deve triggerare la visualizazzione del toaster
        //return false

        //filtra la get sui dati pagamento

        /* eslint-disable-next-line */
        if (
            error.config.url.indexOf(globals["app-url-backend"]) !== -1 &&
            (error.config.method.toLowerCase() === "get") !== -1 &&
            error.response.status === 404
        )
            return true;
    }

    addResponseInterceptor = () => {

        let urlComuni, urlProvince, urlSigleProvince, urlNazioni, urlMalattie, urlStrutture, urlReparti,
            urlSegnalazioni, urlFocolai, url, identificativoToaster = null

        let pathMicroservizi = OggettiUtili.pathMicroservizi


        // Add a response interceptor
        axios.interceptors.response.use(
            response => {
                // Do something with response data
                /* console.log("[INTERCEPTOR] Intercepting response");
                console.log("[INTERCEPTOR] Response from " + response.config.url);
                console.log(response); */
                urlComuni = response.config.url.includes("/comuni");
                urlProvince = response.config.url.includes("/province");
                urlSigleProvince = response.config.url.includes("/sigleProvince");
                urlNazioni = response.config.url.includes("/nazioni");
                urlMalattie = response.config.url.includes("/malattie") && !response.config.url.includes("/sezionidatispecifici");
                urlStrutture = response.config.url.includes("/strutture") && !response.config.url.includes("/reparti");
                urlReparti = response.config.url.includes("/reparti");

                url = response.config.url

                pathMicroservizi.forEach(element => {
                    if (url.includes(element.path)) {
                        let timestamp = new Date().toISOString().toString()
                        let timestampModificato = timestamp.replace(/[-T:Z.]/g, "")
                        identificativoToaster = element.codice + "-" + timestampModificato
                    }
                })

                if (urlComuni && (!response.data || response.data.length === 0)) {
                    ToasterSingleton.instance().aggiuntaToaster(
                        {
                            type: "confirm",
                            text: i18next.t("Messages.ERR_COMUNI"),
                            timestamp: Date.now(),
                            identificativo: identificativoToaster
                        }
                    );
                }
                if (urlProvince && (!response.data || response.data.length === 0)) {
                    ToasterSingleton.instance().aggiuntaToaster(
                        {
                            type: "confirm",
                            text: i18next.t("Messages.ERR_PROVINCE"),
                            timestamp: Date.now(),
                            identificativo: identificativoToaster
                        }
                    );
                }
                if (urlSigleProvince && (!response.data || response.data.length === 0)) {
                    ToasterSingleton.instance().aggiuntaToaster(
                        {
                            type: "confirm",
                            text: i18next.t("Messages.ERR_SIGLE_PROV"),
                            timestamp: Date.now(),
                            identificativo: identificativoToaster
                        }
                    );
                }
                if (urlNazioni && (!response.data || response.data.length === 0)) {
                    ToasterSingleton.instance().aggiuntaToaster(
                        {
                            type: "confirm",
                            text: i18next.t("Messages.ERR_NAZIONI"),
                            timestamp: Date.now(),
                            identificativo: identificativoToaster
                        }
                    );
                }
                if (urlMalattie && (!response.data || response.data.length === 0)) {
                    ToasterSingleton.instance().aggiuntaToaster(
                        {
                            type: "confirm",
                            text: i18next.t("Messages.ERR_MALATTIE"),
                            timestamp: Date.now(),
                            identificativo: identificativoToaster
                        }
                    );
                }
                if (urlStrutture && (!response.data || response.data.length === 0)) {
                    ToasterSingleton.instance().aggiuntaToaster(
                        {
                            type: "confirm",
                            text: i18next.t("Messages.ERR_STRUTTURE"),
                            timestamp: Date.now(),
                            identificativo: identificativoToaster
                        }
                    );
                }
                if (urlReparti && (!response.data || response.data.length === 0)) {
                    ToasterSingleton.instance().aggiuntaToaster(
                        {
                            type: "confirm",
                            text: i18next.t("Messages.ERR_REPARTI"),
                            timestamp: Date.now(),
                            identificativo: identificativoToaster
                        }
                    );
                }
                if (response.data.esito) {
                    if (response.data.esito.messaggi && response.data.esito.operationId !== "INVIO_PDF") {
                        for (let i = 0; i < response.data.esito.messaggi.length; i++) {
                            ToasterSingleton.instance().aggiuntaToaster(
                                {
                                    type: Utils.getTypeEsito(response.data.esito.messaggi[i]),
                                    text: i18next.t("Messages." + response.data.esito.messaggi[i].codMsg),
                                    timestamp: Date.now(),
                                    identificativo: identificativoToaster
                                }
                            );
                        }
                    }

                } else {
                    response.toasters = [];
                }

                return response;
            },
            error => {
                // Do something with response error
                /* console.log("[INTERCEPTOR] Intercepting response");
                console.log("[INTERCEPTOR] Error on response from: ", error.config.url);
                console.log(error); */

                url = error.config.url

                pathMicroservizi.forEach(element => {
                    if (url.includes(element.path)) {
                        let timestamp = new Date().toISOString().toString()
                        let timestampModificato = timestamp.replace(/[-T:Z.]/g, "")
                        identificativoToaster = element.codice + "-" + timestampModificato
                    }
                })

                let erroriEspliciti = globals["errori-espliciti"] === "true"
                urlSegnalazioni = error.config.url.includes("/segnalazioni")
                urlFocolai = error.config.url.includes("/focolai")
                let tipoToaster =  urlFocolai || urlSegnalazioni ? "critical" : "confirm"

                let text = erroriEspliciti && error.response && error.response.data
                    ? error.response.data.path + " - " + error.response.data.message
                    : i18next.t("Messages.MSG_GENERICO")

                if (!error.response) {
                    ToasterSingleton.instance().aggiuntaToaster(
                        {
                            type: tipoToaster,
                            text: text,
                            timestamp: Date.now(),
                            identificativo: identificativoToaster
                        }
                    );
                } else if (error.response.status >= 400 && error.response.status < 500) {
                    ToasterSingleton.instance().aggiuntaToaster(
                        {
                            type: tipoToaster,
                            text: text,
                            timestamp: Date.now(),
                            identificativo: identificativoToaster
                        }
                    );
                } else if (error.response.status >= 500 && error.response.status < 600) {
                    ToasterSingleton.instance().aggiuntaToaster(
                        {
                            type: tipoToaster,
                            text: text,
                            timestamp: Date.now(),
                            identificativo: identificativoToaster
                        }
                    );
                }
                /* console.log("error");
                console.log(error.response); */

                return Promise.reject(error);
            }
        );

    }

}

export default Interceptor


